import { Flex, Link, Text } from '@chakra-ui/layout';
import { motion } from 'framer-motion';
import React from 'react';

const MotionFlex = motion(Flex);

export const ProfileCard: React.FC<{
  icon?: JSX.Element;
  label?: string;
  subLabel?: string;
  ctaLabel?: string;
  ctaHref?: string;
  index: number;
}> = ({ subLabel, icon, label, ctaLabel, ctaHref, index }) => {
  const containerVariants = {
    hidden: {
      y: -10,
      opacity: 0,
    },
    visible: {
      y: 0,
      opacity: 1,
      transition: { delay: 0.1 * index },
    },
    exit: {
      y: 10,
      opacity: 0,
      transition: { duration: 0.1 },
    },
  };
  return (
    <MotionFlex
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      p={4}
      boxShadow="md"
      borderRadius="xl"
      align="center"
      direction="column"
      justify="center"
    >
      {icon && icon}

      {label && (
        <Text fontSize="lg" fontWeight="bold" textTransform="uppercase">
          {label}
        </Text>
      )}
      {subLabel && (
        <Text fontSize="sm" textAlign="center">
          {subLabel}
          <br />
          {ctaLabel && ctaHref && (
            <Link fontWeight="bold" target="_blank" href={ctaHref}>
              {ctaLabel}
            </Link>
          )}
        </Text>
      )}
    </MotionFlex>
  );
};
